import "./view.scss";

import Swiper from 'swiper';
import { Scrollbar, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initCarouselSliders() {
    const containers = document.querySelectorAll('.wp-block-falcon-carousel');
    
    containers.forEach((container, index) => {
        const swiperNode = container.querySelector('.swiper'); 
        const scrollbar = container.querySelector('.swiper-scrollbar');
        const pagination = container.querySelector('.swiper-pagination');
        const prevButton = container.querySelector('.swiper-button-prev');
        const nextButton = container.querySelector('.swiper-button-next');

        // Skip if no swiper node or no slides
        if (!swiperNode || !container.childElementCount) {
            return;
        }

        // Check if this is an alternative style carousel
        const isAlternativeStyle = container.classList.contains('carousel-style-alternative');
        const wrapper = swiperNode.querySelector('.swiper-wrapper');
        const slideCount = wrapper ? wrapper.children.length : 0;
        const maxSlidesPerView = isAlternativeStyle ? 1 : 1.2;
        const hasEnoughSlidesForLoop = slideCount >= Math.ceil(maxSlidesPerView) + 2;

        try {
            const slider = new Swiper(swiperNode, {   
                modules: [ Scrollbar, Navigation, Pagination ],             
                direction: 'horizontal',
                centeredSlides: isAlternativeStyle ? false : true,
                createElements: isAlternativeStyle ? false : true,
                loop: hasEnoughSlidesForLoop,
                speed: 600,
                grabCursor: true,
                scrollbar: scrollbar ? {
                    el: scrollbar,
                    draggable: true,
                    dragSize: 50
                } : false,
                navigation: (prevButton && nextButton) ? {
                    nextEl: nextButton,
                    prevEl: prevButton,
                } : false,
                pagination: {
                    el: pagination,
                    type: "fraction",
                },
                spaceBetween: 20,
                slidesPerView: 1,
                breakpoints: {
                  1024: {
                    slidesPerView: isAlternativeStyle ? 1 : 1.2,
                    spaceBetween: 40
                  },
              }
            });

            // Initialize the slider
            slider.init();
                        
            
        } catch (error) {
            console.error(`Failed to initialize carousel ${index}:`, error);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initCarouselSliders();
});
